// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import { useBunzlDispatch } from "@store/Framework/Store/Bunzl/BunzlReducer";

const useHasBeenAddedToList = () => {
    const hasBeenAddedToList = useAppSelector(state => state.bunzl.pages.addToList.hasBeenAddedToList);
    const bunzlDispatch = useBunzlDispatch();
    const addProductToList = (productId: string) => {
        bunzlDispatch({ type: "Pages/MyListDetails/SetHasBeenAddedToList", productId });
    };
    return { hasBeenAddedToList, addProductToList };
};

export default useHasBeenAddedToList;
